
import classNames from 'classnames';
import { parseAsStringEnum, useQueryState } from 'nuqs';

import type { RewardPoolStatus } from '@shared/api/types/rewardPools';
import { REWARD_POOL_STATUS } from '@shared/api/types/rewardPools';
import { useAuth } from '@shared/common/providers/AuthProvider';

export const DEFAULT_STATUS_FILTER_VALUE = REWARD_POOL_STATUS.ACTIVE;

export const statusFiltersInOrder: {
  id: RewardPoolStatus;
  label: string;
}[] = [
  {
    id: REWARD_POOL_STATUS.ACTIVE,
    label: 'Active',
  },
  {
    id: REWARD_POOL_STATUS.CLAIMED,
    label: 'Joined',
  },
  {
    id: REWARD_POOL_STATUS.PENDING,
    label: 'Upcoming',
  },
  {
    id: REWARD_POOL_STATUS.COMPLETED,
    label: 'Ended',
  },
];

export const useRewardPoolsStatusFilterQueryState = () => {
  const { isAuth } = useAuth();
  const validValues = statusFiltersInOrder
    .map(({ id }) => id)
    .filter((id) => isAuth || id !== REWARD_POOL_STATUS.CLAIMED);

  return useQueryState(
    'status',
    parseAsStringEnum<RewardPoolStatus>(validValues)
      .withDefault(DEFAULT_STATUS_FILTER_VALUE)
      .withOptions({
        clearOnDefault: true,
      }),
  );
};

export const StatusFilter = () => {
  const [filter, setFilter] = useRewardPoolsStatusFilterQueryState();
  const { isAuth } = useAuth();

  return (
    <div className="toggle-button-group">
      {statusFiltersInOrder.map(({ id, label }) => {
        const isActive = filter === id;
        const isDisabled = id === REWARD_POOL_STATUS.CLAIMED && !isAuth;

        return (
          <button
            onClick={() => setFilter(id)}
            key={id}
            disabled={isDisabled}
            className={classNames('toggle-button', {
              'toggle-button-active': isActive,
            })}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
